import styled, { css } from 'styled-components';
import bg from '../../../assets/dots-purple.png';
import { devices } from '../../../juristec-ui/core/breakpoints';

export const MainContainer = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(${bg});
  background-repeat: repeat;
  background-size: auto;
  background-position: center center;
  height: 100vh;
  width: 100vw;
  & h2 {
    margin: 0;
    color: ${({ theme }) => theme.primary};
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 10px;
    text-align: center;
    width: 100%;
  }
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 500px;
  max-width: 500px;
  height: 100%;
  max-height: 100vh;
  box-sizing: border-box;
  overflow: auto;
  background-color: ${({ theme }) => theme.background};
  padding: 10px 30px 30px 30px;
  position: relative;

  @media ${devices.desktopS} {
    min-width: 500px;
    max-width: 500px;
  }

  @media ${devices.tablet} {
    min-width: 450px;
    max-width: 450px;
  }

  @media ${devices.phoneL} {
    min-width: 400px;
    max-width: 400px;
  }

  @media ${devices.phoneS} {
    min-width: 100%;
    max-width: 100%;
  }
`;

export const Nav = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 0 10px 0;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  & .go-back-tooltip button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 30px;
    border-radius: 8px;
    border-width: 2px;
    padding: 0;
    box-shadow: none;
  }
`;

export const Logo = styled.img`
  display: block;
  width: 300px;
  margin-bottom: 20px;
`;

export const FormFieldSet = styled.fieldset`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border: none;
  padding: 0;
  margin: 0;
  width: 100%;
  margin: auto 0;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }
  & .errorMessage {
    position: absolute;
    padding-top: 1px;
  }
  & .inputTxt {
    padding-left: 5px;
    border-radius: 0px;
  }
`;

export const MiniLabel = styled.span`
  font-family: 'Roboto', arial, sans-serif;
  margin: 5px auto;
  color: ${({ theme }) => theme.grey};
`;

export const TextOptions = styled.span`
  display: block;
  padding-top: 5px;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.color};
  bottom: 10px;
  left: 10px;
  & > a, span {
    cursor: pointer;
    color: ${({ theme }) => theme.primary};
    font-weight: bold;
    text-decoration-line: none;
  }
`;

export const TextOptionsLink = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.primary};
  font-weight: bold;
  text-decoration-line: none;
`;

export const LanguageButton = styled.button<{ selected: boolean, theme: Record<string, string> }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: solid ${({ theme }) => theme.primary};
  background-color: ${({ selected, theme }) => (selected ? theme.primary : 'transparent')};
  font-size: 18px;
  min-width: 30px;
  height: 30px;
  border-radius: 0;
  border-width: 2px 0;
  padding: 0;
  ${({ theme }) => css`
    text-shadow: 
      -1px -1px 0 ${theme.color}55,  
      1px -1px 0 ${theme.color}55,
      -1px  1px 0 ${theme.color}55,
      1px  1px 0 ${theme.color}55;
  `}
  &:hover {
    background-color: ${({ theme }) => theme.secondary}88;
  }
`;

export const MultiButton = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: auto;
  & div {
    &:first-child button {
      border-radius: 8px 0 0 8px;
      border-width: 2px;
    }
    &:last-child button {
      border-radius: 0 8px 8px 0;
      border-width: 2px;
    }
  }
`;

export const HiddenInput = styled.input`
  position: absolute;
  left: -9999px;
  top: -9999px;
  width: 1px;
  height: 1px;
  border: none;
  background: none;
  color: transparent;
`;
